import styled from "styled-components";

export const ButtonSecondary = ({
  as,
  href,
  className,
  onClick,
  target,
  rel,
  children,
  inverted,
}) => {
  return (
    <Wrapper
      as={as}
      href={href}
      className={className}
      onClick={onClick}
      target={target}
      rel={rel}
      inverted={inverted}
    >
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.button`
  background-color: ${(props) => (props.inverted ? `#ffffff` : `#ee2738`)};
  color: ${(props) => (props.inverted ? `#ee2738` : `#ffffff`)};
  padding: 16px 35px;
  border: none;
  outline: 0;
  cursor: pointer;
  text-transform: uppercase;
  text-decoration: none;
  text-align: center;
  font-weight: 600;

  &:hover {
    background-color: ${(props) => (props.inverted ? `#ee2738` : `#a90d14`)};
    color: #ffffff;
  }
`;
